/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import { Tooltip } from '@material-ui/core';

import Radio from 'common/domain/radio';
import { Percent } from 'common/components/Number';
import LoadingDots from 'common/components/LoadingDots';

import ReachApi from '../../metrics/services/reachApi';
import ReachPerformance from '../../metrics/domain/ReachPerformance';

const Sdiv = styled.div`
  font-size: ${({ theme }) => theme.V2.fonts.h4.size}px;
  display: flex;
  align-items: center;
`;

const InfoIcon = styled.i`
  margin-right: 3px;
  font-size: 20px;
`;

interface Props {
  radio: Radio;
  token: string;

  t: any;
}

interface State {
  performance?: ReachPerformance;
}

class AntennaPerformance extends React.Component <Props, State> {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.fetchReachPerformance();
  }

  componentDidUpdate(prevProps: Props) {
    const { radio } = this.props;
    const prevRadio = prevProps.radio;

    if (!radio.isSame(prevRadio)) {
      this.fetchReachPerformance();
    }
  }

  fetchReachPerformance = () => {
    this.setState({ performance: undefined });

    ReachApi.getReachPerformance(this.props.radio.callSign, this.props.token)
      .then(performance => this.setState({ performance }));
  }

  render() {
    const { t } = this.props;
    const { performance } = this.state;

    return (
      <Sdiv>
        <Tooltip title={t('performanceTooltip')}>
          <InfoIcon className="material-icons" >
          info
          </InfoIcon>
        </Tooltip>
        <span>{t('reachPerformance')}&nbsp;</span>
        {performance &&
          <React.Fragment>
            {performance.performance >= 0 &&
              <span>+</span>
            }
            <Percent value={performance.performance} />
          </React.Fragment>
        }
        {!performance &&
          <LoadingDots />
        }
      </Sdiv>
    );
  }
}

export default withTheme(translate('salesDashboard')(AntennaPerformance));



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/components/AntennaPerformance.js